export const nodeIds = [
	"EGY/CCHE57357_Wave_3_A029/2021|MZ380261.1|2021-05-11",
	"Switzerland/BE-ETHZ-510675/2020|OU174873.1|2021-02-23",
	"USA/MD-CDC-2-3713997/2020|MW495923.1|2020-11-21",
	"USA/UT-UPHL-2104615974/2021|MZ373706.1|2021-01-11",
	"USA/CO-CDC-LC0043436/2021|MZ039160.1|2021-04-05",
	"USA/FL-CDC-STM-000021639/2021|MW778951.1|2021-02-22",
	"USA/MN-CDC-IBX308273162033/2021|MZ295544.1|2021-05-06",
	"England/QEUH-9FB263/2020|OA992622.1|2020-09-29",
	"England/PHEC-YYBFNWK/2021|2021-08-14",
	"USA/PA-CDC-ASC210103965/2021|OK321338.1|2021-09-03",
	"England/LIVE-9B2F5/2020|2020-03-28",
	"Northern_Ireland/NIRE-0048ed/2021|2021-07-03",
	"England/QEUH-9B56A5/2020|OA994785.1|2020-09-03",
	"England/ARCH-000043F9/2021|2021-02-01",
	"Switzerland/VD-ETHZ-500618/2021|OU008180.1|2021-02-12",
	"England/CAMC-141BA76/2021|OU179370.1|2021-03-11",
	"Northern_Ireland/PHEC-N303NB63/2021|2021-07-12",
	"England/BRBR-1E54822/2021|OU725309.1|2021-09-13",
	"USA/WV-CDC-LC0253907/2021|OK276713.1|2021-08-31",
	"USA/FL-CDC-LC0051855/2021|MZ142616.1|2021-04-22",
	"USA/NJ-CDC-LC0008805/2021|MW640140.1|2021-01-20",
	"USA/MS-CDC-LC0254569/2021|OK277543.1|2021-09-02",
	"USA/IL-CDC-LC0063955/2021|MZ342140.1|2021-05-20",
	"England/NORT-290416/2021|OU387840.1|2021-01-11",
	"USA/FL-CDC-LC0069945/2021|MZ411833.1|2021-06-02",
	"Switzerland/SO-ETHZ-470373/2021|OE999870.1|2021-01-25",
	"USA/CA-CDPH-UC514/2020|MW972751.1|2020-12-04",
	"England/HSLL-1BBA6D8/2021|OU590937.1|2021-08-13",
	"USA/SD-SDPHL-0398/2020|MZ611535.1|2020-09-02",
	"USA/MO-CDC-LC0221764/2021|OK152522.1|2021-08-02",
	"USA/RI-CDC-LC0041164/2021|MZ036698.1|2021-04-08",
	"USA/TG814378/2021|MZ915842.1|2021-02-01",
	"IMS-10116-CVDP-47FFE426-60F9-4EE2-899C-77C5F2FFF675|OU118245.1|2021-03-29",
	"USA/CA-CDC-QDX24236267/2021|OK249651.1|2021-04-20",
	"England/BRBR-193E137/2021|OU456693.1|2021-07-13",
	"USA/IL-CDC-ASC210027025/2021|MZ024298.1|2021-03-30",
	"USA/IN-CDC-LC0028650/2021|MW870281.1|2021-03-11",
	"Northern_Ireland/NIRE-001a10/2021|2021-04-17",
	"USA/JJEJ/2021|MW930667.1|2021-02-25",
	"USA/MN-MDH-3201/2021|MW722131.1|2021-01-18",
	"Switzerland/LU-ETHZ-350123/2020|OE997761.1|2020-11-02",
	"England/NEWC-1E9604A/2021|2021-09-16",
	"England/ALDP-1004D8A/2021|OD939586.1|2021-01-12",
	"RNA|OU476116.1|2021-05-29",
	"England/PHEC-Q307Q4CE/2021|2021-07-31",
	"England/MILK-1152320/2021|OD954388.1|2021-01-23",
	"USA/NC-CDC-2-3851532/2021|MW708229.1|2021-01-27",
	"USA/NJ-CDC-ASC210033472/2021|MZ284136.1|2021-04-26",
	"IMS-10116-CVDP-6AF5C8AF-D354-4DF8-9CD7-B9725D4AF2D8|OU128969.1|2021-04-01",
	"USA/FL-CDC-FG-018448/2021|MW932751.1|2021-03-27",
	"Switzerland/BE-ETHZ-33806238/2021|OU721813.1|2021-08-19",
	"USA/PA-CDC-LC0041670/2021|MZ037328.1|2021-04-02",
	"USA/CO-CDC-MMB08728704/2021|MZ434377.1|2021-05-10",
	"Wales/ALDP-1EF9EA5/2021|2021-09-19",
	"USA/WA-UW-21060922027/2021|MZ467936.1|2021-06-09",
	"USA/TX-DSHS-0347/2020|MW114984.1|2020-06-13",
	"Switzerland/TI-UHB-4175841002/2020|OU282024.1|2020-12-23",
	"USA/TX-CDC-IBX863577783677/2021|OK305890.1|2021-09-09",
	"USA/CO-CDC-MMB09028691/2021|OK241671.1|2021-06-01",
	"Switzerland/SO-ETHZ-441024/2020|OE999551.1|2021-01-05",
	"USA/TX-CDC-LC0222291/2021|OK154115.1|2021-08-06",
	"USA/IL-CDC-LC0057340/2021|MZ252394.1|2021-05-06",
	"England/ALDP-17A8765/2021|OU371016.1|2021-06-22",
	"England/LOND-12E69E2/2021|OU395653.1|2021-02-10",
	"IMS-10013-CVDP-05704BDD-54BD-4F99-924A-56187EDA7EE4|OU154653.1|2021-04-16",
	"England/MILK-1C5EBA9/2021|OU614714.1|2021-08-22",
	"Wales/PHWC-15DE45/2020|2020-05-12",
	"England/ALDP-10B6CD5/2021|OD945436.1|2021-01-17",
	"USA/MN-MDH-12611/2021|OK181328.1|2021-09-04",
	"USA/GA-CDC-STM-000070004/2021|MZ290920.1|2021-05-05",
	"Switzerland/ZH-ETHZ-460684/2021|OU009760.1|2021-01-15",
	"Switzerland/AG-UZH-IMV-3ba4e009/2021|OU579004.1|2021-08-04",
	"USA/NJ-PHEL-V21000504/2021|OK290588.1|2021-04-28",
	"USA/NJ-CDC-LC0244909/2021|OK199314.1|2021-08-31",
	"England/PHEC-W30BW9AD/2021|2021-08-24",
	"Germany/2021|OU568105.1|2021-08-08",
	"England/MILK-1C9D0FA/2021|OU619506.1|2021-08-25",
	"USA/MA-CDCBI-CRSP_FUGUOUR5JMHPIY5N/2021|OK177361.1|2021-09-08",
	"USA/CO-CDPHE-2100232934/2021|MW629209.1|2021-01-16",
	"USA/WV-CDC-LC0022672/2021|MW780223.1|2021-02-25",
	"USA/WA-UW-2021041001977/2021|MZ240057.1|2021-04-10",
	"IMS-10061-CVDP-E92AE861-37E7-4A22-8EDD-49176E661AD6|OU130226.1|2021-04-15",
	"Iceland/226/2020|OU161828.1|2020-03-16",
	"USA/WV119559/2021|MZ498358.1|2021-05-03",
	"USA/FL-CDC-LC0265107/2021|OK281252.1|2021-09-08",
	"Scotland/QEUH-152D5CA/2021|OU263449.1|2021-04-22",
	"USA/CA-CDC-LC0016406/2021|MW706085.1|2021-02-10",
	"England/MILK-118E6B9/2021|OD960855.1|2021-01-24",
	"USA/NY-CDC-LC0024879/2021|MW986327.1|2021-03-04",
	"USA/TX-CDC-ASC210074666/2021|MZ185204.1|2021-04-17",
	"AUS/VIC12029/2020|MW184319.1|2020-07-28",
	"USA/AL-CDC-LC0218808/2021|OK153866.1|2021-08-23",
	"England/NOTT-10E3DB/2020|2020-03-22",
	"IMS-10013-CVDP-3230AEA2-4FBC-4358-A498-890FEA99B465|OU136178.1|2021-03-29",
	"England/NORW-3012692/2021|OU594937.1|2021-08-04",
	"Switzerland/SO-ETHZ-440746/2021|OE999520.1|2021-01-03",
	"USA/CO-CDC-MMB08872277/2021|MZ431861.1|2021-05-19",
	"DJI/NAMRU3_B85/2021|MZ970737.1|2021-04-12",
	"USA/FL-CDC-LC0238954/2021|OK195713.1|2021-08-26",
	"Switzerland/AG-ETHZ-33750019/2021|OU702017.1|2021-08-15",
	"England/NORW-304A34C/2021|2021-09-22",
	"USA/FL-CDC-LC0161655/2021|MZ937204.1|2021-08-01",
	"IMS-10013-CVDP-9B44E29D-766F-434C-B82D-BBC4685C17E3|OU166786.1|2021-04-20",
	"Iceland/5492/2020|OU167349.1|2020-12-05",
	"USA/UT-UPHL-201028541/2020|MW181559.1|2020-05-08",
	"USA/MN-MDH-1598/2020|MT997716.1|2020-05-11",
	"USA/CA-CZB-27010/2021|MW923041.1|2021-02-05",
	"USA/NC-CDC-LC0053653/2021|MZ179509.1|2021-04-26",
	"England/MILK-12612F3/2021|OD984636.1|2021-02-05",
	"USA/DC-CDC-LC0258420/2021|OK278629.1|2021-09-03",
	"USA/PA-CDC-LC0063243/2021|MZ341597.1|2021-05-18",
	"USA/FL-CDC-ASC210075204/2021|MZ187663.1|2021-04-18",
	"USA/TX-CDC-LC0261919/2021|OK282338.1|2021-09-10",
	"USA/CA-CDC-ASC210153915/2021|MZ533335.1|2021-06-22",
	"USA/CO-CDC-MMB09597050/2021|MZ998108.1|2021-08-05",
	"USA/UT-UPHL-210904489476/2021|OK161888.1|2021-08-17",
	"Wales/PHWC-25A8F/2020|2020-03-23",
	"England/BIRM-BCF87G/2021|OU420814.1|2021-06-24",
	"England/PHEC-YYBC1NT/2021|2021-08-26",
	"USA/NE-CDC-2-4501070/2021|MZ451755.1|2021-05-27",
	"England/PHEC-1DEE8/2020|2020-04-08",
	"England/ALDP-1BFC546/2021|OU600127.1|2021-08-17",
	"USA/MA-CDCBI-CRSP_TUIAXBTQBG7P6YV7/2021|OK179459.1|2021-09-11",
	"USA/SC-COVID21-3054/2021|OK316886.1|2021-08-06",
	"USA/KY-CDC-LC0218830/2021|OK154085.1|2021-08-24",
	"England/PHEC-Q304Q6CB/2021|2021-07-27",
	"USA/MN-CDC-IBX766343105351/2021|OK305869.1|2021-09-10",
	"USA/NC-CDC-LC0178316/2021|MZ989362.1|2021-08-08",
	"USA/PA-CDC-STM-000003123/2021|MW586012.1|2021-01-14",
	"Switzerland/ZH-ETHZ-430894/2020|OU009241.1|2020-12-26",
	"USA/CA-LACPHL-AA00016/2020|MW389642.1|2020-08-05",
	"USA/CA-CDC-FG-070263/2021|MZ883977.1|2021-08-09",
	"USA/LA-CDC-ASC210277613/2021|OK079539.1|2021-08-05",
	"USA/JEUK/2020|MW930422.1|2020-11-17",
	"USA/KY-CDC-LC0264629/2021|OK281756.1|2021-09-08",
	"USA/CA-CDC-ASC210181236/2021|OK321808.1|2021-08-25",
	"England/ALDP-1F30FDB/2021|2021-09-23",
	"USA/TN-CDC-ASC210274484/2021|OK108017.1|2021-08-04",
	"Germany/2021|OU643168.1|2021-08-10",
	"USA/SC-COVID21-1382/2021|MZ161171.1|2021-04-10",
	"England/ALDP-F90A17/2021|OD949113.1|2021-01-09",
	"USA/NY-CDC-ASC210277540/2021|OK080673.1|2021-08-05",
	"USA/MN-CDC-IBX980707046031/2021|MZ055338.1|2021-04-06",
	"USA/MA-CDCBI-CRSP_34Z5R7VQMGF5OTXB/2021|OK089891.1|2021-09-02",
	"USA/FL-CDC-STM-000017831/2021|MW942074.1|2021-02-16",
	"USA/IL-CDC-STM-000061127/2021|MZ163796.1|2021-04-21",
	"England/PLYM-1A249C2/2021|OU486709.1|2021-07-26",
	"USA/MN-MDH-2278/2020|MW592749.1|2020-12-09",
	"BHR/921532620_S24_L001/2021|OK254069.1|2021-09-16",
	"USA/PA-CDC-LC0041895/2021|MZ037488.1|2021-04-01",
	"England/ALDP-1F27906/2021|2021-09-22",
	"England/ALDP-1E4EEB0/2021|OU728771.1|2021-09-10",
	"TUN/TUN_ADAGE_14-17873/2020|MW452531.1|2020-10-14",
	"USA/PA-CDC-STM-000067512/2021|MZ237587.1|2021-05-02",
	"USA/NY-CDC-FG-085081/2021|MZ999338.1|2021-08-10",
	"England/ALDP-19CDBD5/2021|OU469416.1|2021-07-18",
	"Scotland/QEUH-1E949BA/2021|2021-09-16",
	"England/PHEC-W30BWDCF/2021|2021-08-31",
	"England/CAMC-A664F3/2020|2020-10-11",
	"England/PHEC-YYBYHF3/2021|2021-08-16",
	"USA/FL-CDC-ASC210237952/2021|OK004541.1|2021-08-02",
	"USA/CA-CZB-27807/2021|MW923186.1|2021-01-29",
	"England/MILK-108989B/2021|OD948865.1|2021-01-14",
	"USA/NC-CDC-STM-000015204/2021|MW777013.1|2021-02-15",
	"USA/TX-CDC-ASC210120527/2021|OK237815.1|2021-08-21",
	"Scotland/QEUH-1DC96C5/2021|OU704973.1|2021-09-07",
	"USA/TN-CDC-LC0155033/2021|MZ860546.1|2021-07-29",
	"USA/GA-CDC-STM-000062141/2021|MZ164254.1|2021-04-23",
	"England/ALDP-172F6C3/2021|OU357645.1|2021-06-16",
	"England/CAMC-145BCFC/2021|OU215337.1|2021-03-24",
	"England/QEUH-D12068/2020|OD924016.1|2020-12-27",
	"USA/IN-CDC-2-3880540/2021|MW709186.1|2021-01-27",
	"USA/WA-CDC-UW21083038409/2021|OK158934.1|2021-08-30",
	"Switzerland/GE-HUG-34938788/2021|OU576321.1|2021-08-02",
	"England/OXON-B3558/2020|2020-04-25",
	"PAK/JRCGR_SCV-68/2020|MW960290.1|2020-11-21",
	"USA/FL-CDC-LC0051976/2021|MZ142652.1|2021-04-23",
	"IMS-10116-CVDP-C60DAE84-0564-41BB-96EE-1CB870A3E833|OU185609.1|2021-05-05",
	"USA/CA-CDC-ASC210097943/2021|OK223226.1|2021-09-01",
	"USA/FL-BPHL-3293/2021|MZ340750.1|2021-05-04",
	"Scotland/QEUH-1F49661/2021|2021-09-20",
	"IMS-10013-CVDP-0561EF8A-17B4-4B18-A752-2DC524B640E7|OU074796.1|2021-02-19",
	"USA/FL-CDC-QDX26177946/2021|MZ535232.1|2021-06-23",
	"IMS-10641-CVDP-41911F95-A97C-4728-8731-4F20914514B0|OU125336.1|2021-02-20",
	"IMS-10183-CVDP-AA106585-26F8-4FF0-98F6-A0E1EBC93300|OU121986.1|2021-04-04",
	"England/ALDP-11455C0/2021|OD963336.1|2021-01-22",
	"Switzerland/AG-ETHZ-380233/2020|OD997272.1|2020-11-21",
	"IMS-10020-CVDP-FB1341AE-3072-4D77-A21D-B4F5EFF41539|OU133520.1|2021-04-16",
	"USA/OH-CDC-ASC210000905/2021|MZ259075.1|2021-03-03",
	"England/ALDP-1A579E4/2021|OU528296.1|2021-07-27",
	"USA/JW0972/2021|MZ619818.1|2021-04-12",
	"USA/MI-CDC-ASC210071404/2021|MZ215199.1|2021-04-15",
	"USA/UT-UPHL-2104998564/2020|MZ373922.1|2020-08-16",
	"IMS-10116-CVDP-9F71918D-6156-41CC-910B-F1676821AD37|OU094657.1|2021-03-03",
	"USA/CO-CDC-ASC210031284/2021|MZ283950.1|2021-04-22",
	"England/PLYM-1C73CC9/2021|OU625319.1|2021-08-23",
	"USA/NY-CDC-QDX22282555/2021|MW719832.1|2021-02-21",
	"IMS-10013-CVDP-60F481FE-1142-485B-A490-4858388F282D|OU199087.1|2021-05-10",
	"USA/CA-CDC-ASC210099547/2021|OK223367.1|2021-09-02",
	"USA/FHCRC-20808/2020|MW593635.1|2020-07-17",
	"England/NORT-1BBA359/2021|OU420457.1|2021-05-10",
	"USA/PR-CDC-ASC210006389/2021|MZ259434.1|2021-03-16",
	"USA/IL-CDC-ASC210064124/2021|MZ293944.1|2021-05-16",
	"Switzerland/BL-ETHZ-551374/2020|OU181701.1|2020-12-14",
	"Scotland/EDB1076/2020|2020-04-07",
	"IMS-10209-CVDP-0632BF34-BC47-4967-9562-199F659A4CFD|OU117875.1|2021-03-12",
	"IMS-10150-CVDP-86E19AF9-F1E9-4E72-8E2F-38F654C59B1C|OU323260.1|2021-06-10",
	"USA/GA-CDC-STM-000041020/2021|MW912258.1|2021-03-21",
	"USA/NY-PRL-2021_0414_00K10/2021|MZ640588.1|2021-04-13",
	"England/CAMC-F7BAC7/2021|OD932426.1|2021-01-09",
	"Switzerland/GE-HUG-35191363/2021|OU699980.1|2021-08-28",
	"USA/CA-CZB-28517/2021|MW921978.1|2021-03-04",
	"Switzerland/BL-ETHZ-490281/2021|OE996420.1|2021-02-05",
	"USA/LA-BIE-LSUH002143/2021|OK287884.1|2021-09-11",
	"England/MILK-1F9A4FE/2021|2021-09-27",
	"USA/MS-CDC-LC0240076/2021|OK196185.1|2021-09-01",
	"Switzerland/AG-UZH-IMV-3ba4f556/2021|OU674360.1|2021-08-25",
	"Wales/PHWC-4C47C3/2021|2021-01-31",
	"USA/IL-CDC-LC0053419/2021|MZ179282.1|2021-04-26",
	"USA/FL-CDC-STM-000068784/2021|MZ279297.1|2021-05-03",
	"IMS-10117-CVDP-73181522-7EE9-4DDD-9A0D-B449545258C1|OU107711.1|2021-03-10",
	"Wales/PHWC-PDKOFI/2021|2021-08-27",
	"Switzerland/ZH-UZH-IMV-3ba4fb63/2021|OU721442.1|2021-09-07",
	"England/ALDP-1B62D43/2021|OU545895.1|2021-08-07",
	"USA/WA-CDC-UW21050171988/2021|MZ217564.1|2021-05-01",
	"USA/CGS_1000003/2021|MW766355.1|2021-02-24",
	"USA/AZ-CDC-LC0007658/2021|MW637906.1|2021-01-15",
	"USA/MA-CDCBI-CRSP_53G4OFAUTU67PS7W/2021|MZ145455.1|2021-04-26",
	"USA/SC-COVID21-2544/2021|MZ852028.1|2021-07-22",
	"USA/IL-CDC-LC0002162/2020|MW636026.1|2020-12-26",
	"USA/PA-CDC-STM-000021577/2021|MW778898.1|2021-02-22",
	"USA/GA-CDC-LC0037003/2021|MZ001436.1|2021-03-28",
	"USA/WI-CDC-FG-088280/2021|OK213767.1|2021-08-14",
	"England/ALDP-133F4E8/2021|OU036541.1|2021-02-25",
	"USA/GA-CDC-QDX27493634/2021|MZ965595.1|2021-08-04",
	"England/ALDP-1452BCB/2021|OU203070.1|2021-03-22",
	"USA/MN-MDH-8514/2020|MZ593545.1|2020-12-17",
	"USA/NY-CDC-LC0038471/2021|MZ002816.1|2021-04-01",
	"USA/LA-CDC-2-4084826/2021|MW888175.1|2021-01-12",
	"England/ALDP-1F198EC/2021|2021-09-22",
	"USA/MI-CDC-ASC210059234/2021|MZ280488.1|2021-05-04",
	"USA/FL-CDC-LC0150812/2021|MZ858765.1|2021-07-27",
	"England/PHEC-1586F7/2021|2021-01-22",
	"England/PLYM-1C9DC6F/2021|OU619965.1|2021-08-25",
	"England/CAMC-9427C8/2020|OA978752.1|2020-07-27",
	"USA/WI-CDC-LC0049349/2021|MZ073102.1|2021-04-14",
	"England/MILK-BB0532/2020|OD907569.1|2020-11-17",
	"USA/HI-CDC-2-4014285/2021|MW792841.1|2021-02-22",
	"USA/MO-UMGC-11598/2021|MZ994829.1|2021-08-18",
	"USA/HI-CDC-LC0224869/2021|OK129472.1|2021-08-14",
	"AUS/VIC16217/2020|MW276972.1|2020-10-07",
	"England/ALDP-1AAF5F8/2021|OU525214.1|2021-08-02",
	"IMS-10020-CVDP-1DE07AA1-56D4-46B4-9AF2-416563971728|OU100401.1|2021-03-15",
	"USA/4530679/2021|MW720851.1|2021-02-10",
	"USA/UT-UPHL-210919286132/2021|OK287531.1|2021-08-24",
	"England/ALDP-153A797/2021|OU270670.1|2021-04-25",
	"IMS-10257-CVDP-125B5F78-D5A8-40DF-90B8-4E8364BDD5CE|OU199614.1|2021-05-03",
	"USA/NJ-CDC-ASC210073472/2021|MZ271498.1|2021-04-16",
	"England/QEUH-150B735/2021|OU256285.1|2021-04-15",
	"USA/MO-CDC-LC0219961/2021|OK154692.1|2021-08-11",
	"USA/MA-CDC-QDX26489215/2021|OK249232.1|2021-06-30",
	"England/ALDP-1352F66/2021|OU032112.1|2021-02-26",
	"USA/ID-CDC-LC0249499/2021|OK201941.1|2021-08-25",
	"USA/CT-UW-3845/2020|MT358693.1|2020-03-25",
	"USA/DC-CDC-LC0044399/2021|MZ039736.1|2021-04-08",
	"USA/UT-UPHL-210911719733/2021|OK166306.1|2021-08-24",
	"USA/TX-CDC-ASC210099360/2021|OK228312.1|2021-09-02",
	"England/MILK-1A4D51A/2021|OU492988.1|2021-07-28",
	"Scotland/QEUH-15A8FE7/2021|OU289114.1|2021-05-21",
	"USA/CA-CDC-ASC210106223/2021|MZ384160.1|2021-05-29",
	"USA/TN-CDC-4157920-001/2021|MZ436120.1|2021-04-28",
	"USA/NJ-CDC-LC0257211/2021|OK281516.1|2021-09-08",
	"USA/MI-CDC-LC0041784/2021|MZ037344.1|2021-03-30",
	"USA/GA-CDC-ASC210180280/2021|OK303779.1|2021-08-27",
	"IND/GBRC829/2021|MZ413375.1|2021-05-06",
	"IMS-10013-CVDP-84F2ADA2-6E83-4598-A005-97ABDE3ED8F1|OU085381.1|2021-02-25",
	"England/BRBR-1A78F90/2021|OU510251.1|2021-07-29",
	"USA/TX-CDC-FG-080323/2021|MZ899348.1|2021-08-13",
	"USA/PA-CDC-QDX22491110/2021|MW749605.1|2021-02-26",
	"England/QEUH-A8C4F7/2020|OB992114.1|2020-10-18",
	"USA/TG796024/2021|MZ915349.1|2021-03-20",
	"USA/NY-CDC-ASC210125559/2021|OK224815.1|2021-08-31",
	"USA/IL-CDC-ASC210002181/2021|MZ258666.1|2021-03-04",
	"USA/MN-UMGC-10534/2021|OK048513.1|2021-08-19",
	"England/ALDP-F74B8F/2021|OD944538.1|2021-01-02",
	"USA/JEIW/2020|MW923444.1|2020-11-05",
	"USA/CA-CDC-ASC210027658/2021|MW990757.1|2021-03-30",
	"USA/TX-CDC-QDX28468167/2021|OK268705.1|2021-09-05",
	"USA/PA-CDC-STM-000017125/2021|MW777747.1|2021-02-16",
	"USA/TN-CDC-ASC210239445/2021|OK002207.1|2021-08-03",
	"England/QEUH-9F3AAF/2020|OA992970.1|2020-09-24",
	"USA/TN-CDC-ASC210195114/2021|OK119049.1|2021-08-19",
	"USA/PA-CDC-LC0124868/2021|OK124996.1|2021-07-25",
	"USA/CA-CDC-FG-088708/2021|OK054937.1|2021-08-17",
	"USA/NY-CDC-QDX23396224/2021|MW930879.1|2021-03-28",
	"Switzerland/ZH-ETHZ-490998/2021|OU011521.1|2021-02-11",
	"BGD/DNAS_isl_SM-12/2020|MT745761.1|2020-06-30",
	"Netherlands/Zeeland_18/2020|LR883882.1|2020-04-03",
	"USA/NY-CUIMC-NP-4462/2021|MZ702378.1|2021-01-18",
	"England/SHEF-10C6FAC/2021|2021-02-13",
	"USA/MA-CDC-STM-000065970/2021|MZ228788.1|2021-04-29",
	"England/PHEC-313BCA/2021|2021-05-31",
	"USA/WV-CDC-LC0060092/2021|MZ306787.1|2021-05-14",
	"USA/CO-CDC-2-3921629/2021|MW731011.1|2021-01-05",
	"England/QEUH-B68CBC/2020|OC997885.1|2020-11-11",
	"USA/CO-CDC-MMB09312238/2021|MZ650589.1|2021-07-06",
	"Switzerland/SO-ETHZ-510807/2020|OU000457.1|2021-02-24",
	"USA/WA-UW-2021040960542/2021|MZ231782.1|2021-04-09",
	"Switzerland/AG-ETHZ-450636/2021|OD997745.1|2021-01-08",
	"USA/MN-CDC-IBX848378887610/2021|OK219336.1|2021-08-16",
	"England/PHWC-PDNWKZ/2021|2021-08-09",
	"USA/CA-CDC-FG-109155/2021|OK106423.1|2021-08-31",
	"RNA|OU475620.1|2021-05-06",
	"USA/JW0346/2021|MZ619444.1|2021-02-26",
	"USA/CA-CDC-ASC210188230/2021|OK008528.1|2021-08-10",
	"IMS-10023-CVDP-48DD5D26-45F2-4E8C-9B84-45AEF59B5B72|OU099880.1|2021-03-10",
	"USA/TX-CDC-FG-034159/2021|MZ243292.1|2021-05-04",
	"England/ALDP-C89346/2020|OD915870.1|2020-12-16",
	"England/PHEC-14DE48/2020|2020-11-09",
	"USA/FL-CDC-LC0194292/2021|OK097055.1|2021-08-16",
	"USA/MN-UMGC-4451/2021|MZ519634.1|2021-06-21",
	"USA/FL-CDC-LC0062221/2021|MZ342318.1|2021-05-19",
	"England/PLYM-1F54584/2021|2021-09-24",
	"USA/NY-CDC-LC0177085/2021|MZ988584.1|2021-08-06",
	"IMS-10013-CVDP-00454|OU080203.1|2021-01-20",
	"USA/IN-CDC-LC0270366/2021|OK308930.1|2021-08-31",
	"USA/MA-CDCBI-CRSP_7YOFM3UMTX7Y6EOA/2021|MZ665783.1|2021-07-20",
	"Estonia/Cov11306/2021|OU370759.1|2021-04-03",
	"USA/FL-CDC-ASC210206755/2021|OK014393.1|2021-08-01",
	"USA/CO-CDC-ASC210185613/2021|OK007815.1|2021-08-06",
	"USA/FL-CDC-LC0129379/2021|OK124429.1|2021-07-22",
	"IMS-10013-CVDP-ACE75D50-D8F2-4E6B-BE8C-63ECAFCFC377|OU149405.1|2021-04-16",
	"England/QEUH-B7E9DA/2020|OC999701.1|2020-11-14",
	"USA/TG785092/2020|MZ911586.1|2020-11-05",
	"USA/AK-PHL9137/2021|MZ349059.1|2021-05-24",
	"USA/WA-CDC-UW21072314640/2021|OK111540.1|2021-07-23",
	"USA/COVID20-0766/2020|MW002806.1|2020-06-26",
	"USA/FL-BPHL-1461/2020|MW040671.1|2020-04-09",
	"USA/TX-CDC-FG-122436/2021|OK259239.1|2021-09-12",
	"Scotland/CVR9465/2021|2021-08-07",
	"USA/CT-CDC-QDX24941131/2021|MZ321156.1|2021-05-10",
	"USA/VA-CDC-LC0247580/2021|OK201010.1|2021-09-01",
	"USA/MA-CDC-STM-000045572/2021|OK191256.1|2021-03-28",
	"Switzerland/BL-ETHZ-431038/2020|OE995681.1|2020-12-28",
	"England/OXON-AE7E1/2020|2020-03-23",
	"England/MILK-9F1BAE/2020|OA994083.1|2020-09-24",
	"England/MILK-1A23C24/2021|OU485424.1|2021-07-26",
	"USA/NE-CDC-ASC210054203/2021|MZ211401.1|2021-04-07",
	"England/BHRT-24B3FAB/2020|OA971699.1|2020-08-11",
	"USA/UT-CDC-ASC210277441/2021|OK080146.1|2021-08-05",
	"England/LOND-12F7641/2021|OU396309.1|2021-01-21",
	"USA/IN-CDC-IBX262386163313/2021|MZ728575.1|2021-07-16",
	"USA/CA-CZB-9962/2020|MZ842606.1|2020-05-05",
	"England/ALDP-9E9C1F/2020|OA989614.1|2020-09-23",
	"USA/FL-CDC-ASC210131921/2021|OK304361.1|2021-09-05",
	"USA/AZ-5174/2021|OK110236.1|2021-08-30",
	"USA/FL-CDC-QDX24476622/2021|MZ226106.1|2021-04-29",
	"USA/UT-UPHL-210603995912/2021|MZ363117.1|2021-05-18",
	"IMS-10023-CVDP-38A272C1-ADC9-48F6-9BA7-7905372DB889|OU326616.1|2021-05-24",
	"USA/NC-CDC-LC0096307/2021|MZ850214.1|2021-07-09",
	"USA/IA-CDC-ASC210182345/2021|OK321469.1|2021-08-30",
	"USA/WV-CDC-ASC210009767/2021|MW994715.1|2021-03-18",
	"England/BIRM-BCYGDG/2021|OB998002.1|2021-02-24",
	"USA/OR-CDC-ASC210063171/2021|MZ272731.1|2021-05-13",
	"England/QEUH-B9E46A/2020|OD908471.1|2020-11-18",
	"USA/UT-UPHL-2009675/2020|MW206342.1|2020-07-26",
	"USA/NC-CDC-LC0140933/2021|MZ860770.1|2021-07-24",
	"England/ALDP-94F9B6/2020|OA977223.1|2020-06-16",
	"IMS-10150-CVDP-3180DEE0-FB8A-4BA1-8622-88A8E7EE933B|OU219949.1|2021-05-26",
	"USA/AZ-CDC-LC0204614/2021|OK101552.1|2021-08-15",
	"England/NORT-1BCBA7E/2021|OU391658.1|2021-05-31",
	"USA/MD-CDC-LC0065587/2021|MZ371206.1|2021-05-27",
	"Switzerland/TG-ETHZ-510551/2020|OU007501.1|2020-11-16",
	"USA/WV-CDC-LC0219302/2021|OK154057.1|2021-08-23",
	"USA/NJ-CDC-LC0023765/2021|MW986205.1|2021-03-01",
	"England/QEUH-138F0B8/2021|OU088485.1|2021-02-27",
	"USA/AZ-4884/2021|MZ960220.1|2021-08-05",
	"England/ALDP-15A132E/2021|OU295208.1|2021-05-18",
	"USA/NMDOH-2020214555/2020|MW493674.1|2020-07-14",
	"England/QEUH-A5E300/2020|OA995413.1|2020-10-12",
	"USA/NC-CDC-LC0051891/2021|MZ142511.1|2021-04-21",
	"England/QEUH-1C2F4C4/2021|OU600948.1|2021-08-19",
	"USA/IL-CDC-LC0250671/2021|OK202491.1|2021-08-24",
	"England/ALDP-10921B2/2021|OD940444.1|2021-01-17",
	"England/MILK-189134C/2021|OU415021.1|2021-07-05",
	"USA/FL-CDC-ASC210110779/2021|MZ565792.1|2021-06-22",
	"USA/NC-CDC-ASC210269926/2021|OK005230.1|2021-08-03",
	"England/MILK-11D7E5F/2021|OD964491.1|2021-01-29",
	"Switzerland/BE-ETHZ-440379/2021|OD999090.1|2021-01-07",
	"England/MILK-1523DCC/2021|OU265882.1|2021-04-20",
	"IND/GBRC262/2020|MT758439.1|2020-06-11",
	"USA/IN-CDC-LC0063186/2021|MZ341589.1|2021-05-18",
	"USA/GA-CDC-LC0265190/2021|OK280456.1|2021-09-07",
	"England/NORT-2966B0/2020|OA964652.1|2020-04-25",
	"USA/GA-CDC-LC0009456/2021|MW641382.1|2021-01-25",
	"England/PLYM-19F7F9A/2021|OU478978.1|2021-07-23",
	"USA/NJ-CDC-ASC210006436/2021|MW993678.1|2021-03-13",
	"IMS-10267-CVDP-00945836-CD3F-4817-9B23-9127487C6F91|OU325950.1|2021-05-30",
	"England/ALDP-19C5D7D/2021|OU469909.1|2021-07-20",
	"USA/CA-CDC-LC0024732/2021|MW781368.1|2021-02-20",
	"Wales/PHWC-PYI8JN/2021|2021-07-18",
	"England/ALDP-1187498/2021|OD961117.1|2021-01-25",
	"USA/CA-CDC-STM-000059459/2021|MZ154124.1|2021-04-18",
	"England/BRBR-19CF177/2021|OU468756.1|2021-07-21",
	"USA/TX-CDC-QDX26488371/2021|MZ654941.1|2021-07-02",
	"England/ALDP-1F28228/2021|2021-09-19",
	"USA/GA-CDC-LC0144499/2021|MZ865848.1|2021-07-14",
	"England/PHEC-155D5F/2021|2021-01-18",
	"USA/GA-CDC-ASC210180111/2021|OK304085.1|2021-08-30",
	"IND/Barcode29MN908947.3/2021|OK189638.1|2021-09-10",
	"IMS-10267-CVDP-7BBC586E-606F-4C3D-9A44-D70964FA2A56|OU211580.1|2021-05-14",
	"USA/NV-CDC-LC0105082/2021|MZ784390.1|2021-07-11",
	"USA/NY-CDC-FG-052698/2021|MZ728028.1|2021-07-22",
	"USA/KS-CDC-LC0016578/2021|MW706353.1|2021-02-09",
	"England/ALDP-139FCEE/2021|OU051880.1|2021-03-06",
	"USA/NC-CDC-LC0196478/2021|OK098587.1|2021-08-17",
	"USA/TX-CDC-QDX24087568/2021|OK248563.1|2021-04-19",
	"IND/CMP_30_FMR/2020|MW645474.1|2020-09-09",
	"IMS-10117-CVDP-261411B2-685D-4D0D-99EA-293DEBCA04E9|OU122024.1|2021-03-26",
	"USA/TN-CDC-ASC210016018/2021|MZ255663.1|2021-03-23",
	"USA/MD-CDC-LC0000399/2020|MW635488.1|2020-12-27",
	"USA/MN-CDC-IBX921311839164/2021|OK305461.1|2021-09-08",
	"USA/OR-CDC-2-3693568/2020|MW406617.1|2020-11-17",
	"USA/SC-CDC-LC0192851/2021|MZ946506.1|2021-08-11",
	"USA/AZ-4378/2021|MZ637456.1|2021-07-10",
	"USA/TX-CDC-QDX22290556/2021|MW803480.1|2021-02-21",
	"USA/GA-CDC-LC0194488/2021|OK097415.1|2021-08-17",
	"IMS-10020-CVDP-19F76519-77FA-43AE-8F35-2CB1D8350C4F|OU093572.1|2021-03-11",
	"USA/CA-CDC-ASC210185259/2021|OK009341.1|2021-08-06",
	"USA/NC-CDC-LC0193222/2021|MZ946788.1|2021-08-13",
	"England/NORT-YYN1T8/2021|2021-08-30",
	"England/CAMC-13B7CE0/2021|OU068575.1|2021-03-10",
	"England/PHEC-2FF345/2021|2021-03-03",
	"USA/NM-CDC-LC0018783/2021|MW707827.1|2021-02-15",
	"USA/MD-MDH-1143/2021|MW704433.1|2021-02-09",
	"USA/TG935314/2020|MZ917759.1|2020-10-26",
	"USA/AL-UAB-GX346/2021|MZ558274.1|2021-06-04",
	"USA/WA-UW-21051474187/2021|MZ394495.1|2021-05-14",
	"England/QEUH-A332B9/2020|2020-10-05",
	"Switzerland/BE-ETHZ-34055847/2021|OU727074.1|2021-09-09",
	"USA/FL-CDC-STM-000034787/2021|MW907953.1|2021-03-13",
	"USA/NV-CDC-LC0143985/2021|MZ865182.1|2021-07-16",
	"England/MILK-16ACE6D/2021|2021-06-12",
	"USA/MA-CDC-QDX24476850/2021|MZ226139.1|2021-04-26",
	"England/CAMC-B37533/2020|OB993394.1|2020-11-05",
	"USA/MN-MDH-13976/2021|OK324641.1|2021-09-03",
	"England/NOTT-2486F9/2020|OU031085.1|2020-12-16",
	"USA/CA-CDC-FG-123856/2021|OK259966.1|2021-09-14",
	"England/PLYM-1AF5E16/2021|OU550726.1|2021-08-05",
	"USA/IL-CDC-LC0051764/2021|MZ142400.1|2021-04-24",
	"USA/MD-CDC-ASC210034322/2021|MZ186020.1|2021-04-25",
	"Scotland/QEUH-150AE04/2021|OU257511.1|2021-04-16",
	"England/MILK-1C0304A/2021|OU605642.1|2021-08-17",
	"IMS-10117-CVDP-1A6284DC-EA38-4680-96B9-0FAD9D31F158|OU130326.1|2021-03-08",
	"Iceland/5183/2020|OU166876.1|2020-11-05",
	"USA/TX-CDC-FG-022537/2021|MZ033743.1|2021-04-05",
	"IMS-10082-CVDP-2C3DE73A-684F-430B-9953-E6A48F4C1216|OU078312.1|2021-02-05",
	"England/HSLL-1B77F54/2021|OU559073.1|2021-08-11",
	"England/MILK-A45885/2020|OA996526.1|2020-10-06",
	"Scotland/QEUH-1844AAD/2021|OU425615.1|2021-07-02",
	"RNA|OU471686.1|2021-03-08",
	"USA/MN-MDH-7992/2021|MZ362507.1|2021-05-21",
	"USA/CA-CDC-FG-006467/2021|MW859538.1|2021-03-06",
	"England/CAMC-1322EBD/2021|OU089111.1|2021-02-22",
	"IMS-10013-CVDP-00942|OU077394.1|2021-01-25",
	"Wales/ALDP-12DC09F/2021|2021-02-15",
	"England/QEUH-18D488A/2021|OU437647.1|2021-07-07",
	"USA/NY-CDC-LC0040090/2021|MZ036000.1|2021-04-02",
	"USA/MA-MASPHL-03778/2021|MZ334421.1|2021-05-16",
	"USA/FL-CDC-ASC210210697/2021|OK013627.1|2021-08-02",
	"IMS-10116-CVDP-92BBA7C9-C1D8-4DB1-82DA-AC4610CE6496|OU125274.1|2021-04-09",
	"USA/SC-CDC-QDX21398917/2021|MW666895.1|2021-01-24",
	"England/MILK-1C90DA5/2021|OU627570.1|2021-08-24",
	"Pakistan/UHS2-Pak-225/2021|OU599541.1|2021-06-11",
	"USA/MI-CDC-LC0060089/2021|MZ306721.1|2021-05-13",
	"Germany/2021|OU648311.1|2021-08-18",
	"USA/NJ-CDC-LC0034163/2021|MW903323.1|2021-03-16",
	"USA/FL-CDC-ASC210206951/2021|OK015874.1|2021-08-01",
	"Switzerland/ZH-ETHZ-480303/2021|OU010187.1|2021-02-01",
	"England/NORT-1BB7B18/2021|OU395342.1|2021-05-02",
	"Switzerland/SO-ETHZ-450844/2021|OE999640.1|2021-01-09",
	"IMS-10150-CVDP-27505468-16BD-41AE-A028-BD5AF22030BA|OU202888.1|2021-05-18",
	"USA/0-89080-3/2021|MZ235418.1|2021-02-04",
	"England/QEUH-B6AD99/2020|OC998972.1|2020-11-11",
	"USA/CA-CDPH-3000128762/2021|OK313919.1|2021-07-26",
	"England/ALDP-1633302/2021|OU321978.1|2021-06-01",
	"USA/CA-CDC-ASC210039890/2021|MZ414513.1|2021-03-31",
	"England/ALDP-1EAA544/2021|2021-09-16",
	"IMS-10209-CVDP-56601921-CFE6-448F-B591-3E792F8082BE|OU360084.1|2021-06-06",
	"IMS-10013-CVDP-01703|OU075898.1|2021-02-02",
	"England/ALDP-19EAFE5/2021|OU472760.1|2021-07-22",
	"Switzerland/SO-ETHZ-480880/2021|OU000049.1|2021-01-05",
	"England/MILK-1A24E3C/2021|OU477340.1|2021-07-26",
	"USA/FL-CDC-ASC210039353/2021|MZ015283.1|2021-03-31",
	"IMS-10591-CVDP-000031|OU072057.1|2021-01-26",
	"AUS/VIC5304/2020|MT971259.1|2020-07-18",
	"Switzerland/BS-UHB-65264325/2020|OU281848.1|2020-10-28",
	"IMS-10183-CVDP-CB1EF25C-0BD7-4180-A8FB-4E1F54B21B3A|OU140067.1|2021-04-16",
	"USA/CO-CDC-MMB09231634/2021|MZ532961.1|2021-06-23",
	"USA/CA-CDC-FG-108146/2021|OK107379.1|2021-08-28",
	"USA/MA-CDC-QDX22285248/2021|MW975501.1|2021-02-20",
	"England/ALDP-1E2D3E5/2021|OU731227.1|2021-09-08",
	"England/ALDP-1892FB0/2021|OU430337.1|2021-07-04",
	"England/MILK-1EB7B06/2021|2021-09-17",
	"USA/CA-CDC-LC0170036/2021|MZ943143.1|2021-07-22",
	"USA/RI-CDCBI-RIDOH_10359/2021|MZ397251.1|2021-05-27",
	"USA/TG794425/2020|MZ914783.1|2020-10-15",
	"USA/SD-CDC-2-4012856/2021|MW792847.1|2021-03-02",
	"USA/NC-CDC-LC0050554/2021|MZ141287.1|2021-04-20",
	"IMS-10116-CVDP-008FCA38-0FDA-469D-8E10-CEF2964AB803|OU217005.1|2021-05-19",
	"USA/CA-CDC-ASC210239827/2021|OK009097.1|2021-08-06",
	"USA/TX-CDC-LC0172895/2021|MZ944082.1|2021-07-24",
	"USA/TG745056/2020|MZ908841.1|2020-12-18",
	"USA/CA-CDPH-3000127939/2021|OK313826.1|2021-06-23",
	"USA/PA-CDC-STM-000055990/2021|MZ100261.1|2021-04-11",
	"Switzerland/BE-ETHZ-33753045/2021|OU701877.1|2021-08-16",
	"USA/UT-UPHL-2104406377/2020|MZ295053.1|2020-08-20",
	"USA/DC-CDC-LC0132777/2021|OK123086.1|2021-07-22",
	"USA/UT-UPHL-2104540035/2021|MZ189604.1|2021-01-25",
	"USA/VA-CDC-LC0243056/2021|OK198168.1|2021-09-01",
	"USA/NY-CDC-QDX23572197/2021|MW964979.1|2021-03-30",
	"USA/CA-CDC-FG-116046/2021|OK186408.1|2021-09-06",
	"IMS-10013-CVDP-9EB0992B-57F3-405E-9FCF-BC71CD4843CA|OU204823.1|2021-05-03",
	"England/ALDP-1B4BF2C/2021|OU546660.1|2021-08-09",
	"England/ALDP-6FC9E8/2020|OA979508.1|2020-06-30",
	"USA/GA-CDC-STM-000016713/2021|MW777867.1|2021-02-15",
	"England/MILK-19CB023/2021|OU468493.1|2021-07-21",
	"England/NORW-13EDCA5/2021|OU490092.1|2021-07-09",
	"England/ALDP-1AB1317/2021|OU522271.1|2021-08-02",
	"USA/PA-CDC-ASC210050566/2021|MZ084743.1|2021-04-07",
	"USA/AL-CDC-LC0255999/2021|OK276586.1|2021-08-30",
	"USA/NY-CDC-LC0262185/2021|OK282442.1|2021-09-10",
	"USA/CA-CDC-LC0018946/2021|MW707942.1|2021-02-15",
	"USA/CA-CDC-FG-020356/2021|MW992665.1|2021-04-11",
	"England/CAMC-B370BA/2020|OB993019.1|2020-11-05",
	"Switzerland/VS-ICH-2210843599/2021|OU619006.1|2021-08-20",
	"USA/MO-CDC-ASC210179038/2021|OK302379.1|2021-08-24",
	"USA/FL-CDC-LC0177746/2021|MZ989313.1|2021-08-07",
	"USA/UT-UPHL-2103157835/2021|MW876926.1|2021-01-13",
	"Switzerland/ZH-ETHZ-510679/2020|OU011735.1|2021-02-23",
	"Switzerland/SO-ETHZ-200071/2020|OU188736.1|2020-07-16",
	"Switzerland/GE-HUG-34518511/2021|OU378399.1|2021-06-18",
	"USA/MO-CDC-QDX21568230/2021|MW665594.1|2021-01-29",
	"USA/VA-CDC-LC0226595/2021|OK131946.1|2021-08-24",
	"England/ALDP-1B0E787/2021|OU555810.1|2021-08-06",
	"England/MILK-18B57DD/2021|OU436394.1|2021-07-08",
	"USA/MS-CDC-2-4044042/2021|MW849874.1|2021-03-03",
	"Scotland/QEUH-160DD30/2021|OU315221.1|2021-06-02",
	"England/PHEC-R307RC99/2021|2021-08-01",
	"England/PLYM-17D4663/2021|OU376957.1|2021-06-27",
	"England/ALDP-149C3AF/2021|OU219425.1|2021-03-29",
	"IMS-10117-CVDP-ED41C4B6-A8DE-463C-9ECE-995CD87B57EF|OU108574.1|2021-03-16",
	"USA/TX-CDC-FG-124136/2021|OK260160.1|2021-09-04",
	"IMS-10013-CVDP-02006|OU080952.1|2021-02-06",
	"USA/CA-CZB-10856/2020|MW276376.1|2020-07-28",
	"Scotland/QEUH-18D4B81/2021|OU444824.1|2021-07-09",
	"USA/IL-CDC-LC0038398/2021|MZ002637.1|2021-03-30",
	"USA/PA-CDC-ASC210036557/2021|MZ282690.1|2021-04-29",
	"England/MILK-1F01AA5/2021|2021-09-21",
	"Wales/PHWC-4D4E07/2021|2021-02-22",
	"England/QEUH-146C2BA/2021|OU211226.1|2021-03-24",
	"England/BIRM-6C8FB/2020|2020-12-06",
	"Scotland/QEUH-12FFD80/2021|OU034253.1|2021-02-22",
	"USA/NJ-PHEL-V21015184/2021|OK303383.1|2021-09-02",
	"USA/KY-CDC-LC0181330/2021|MZ991994.1|2021-08-07",
	"USA/NY-CDC-LC0023847/2021|MW781198.1|2021-03-03",
	"USA/FL-CDC-LC0079380/2021|MZ531127.1|2021-06-21",
	"England/ALDP-136C549/2021|2021-03-01",
	"RNA|OU474246.1|2021-03-24",
	"England/NORW-13EED47/2021|OU488277.1|2021-07-10",
	"USA/GA-CDC-MMB08912659/2021|MZ432104.1|2021-05-22",
	"USA/TN-CDC-ASC210071079/2021|MZ414674.1|2021-04-15",
	"England/MILK-A06826/2020|OA997874.1|2020-10-01",
	"USA/CO-CDC-FG-016020/2021|MW896255.1|2021-03-20",
	"England/ALDP-1183F40/2021|OD975255.1|2021-01-25",
	"England/NEWC-1F0E62C/2021|2021-09-20",
	"USA/VSP6027/2021|OK247345.1|2021-09-02",
	"USA/NV-CDC-QDX28381148/2021|OK268808.1|2021-09-01",
	"Switzerland/SO-UHB-42896556/2021|OU575359.1|2021-06-13",
	"England/BHRT-24B6184/2020|2020-11-19",
	"USA/MO-CDC-QDX28360236/2021|OK269819.1|2021-08-31",
	"USA/FL-CDC-QDX22121286/2021|MW773650.1|2021-02-17",
	"USA/CA-CZB-31885/2021|MZ378592.1|2021-04-19",
	"USA/KY-CDC-LC0242372/2021|OK197538.1|2021-08-31",
	"USA/WI-QDX-4337/2021|MW586860.1|2021-01-15",
	"England/PLYM-1BD613F/2021|OU589188.1|2021-08-16",
	"NorthernIreland/RAND-1D471EC/2021|OU726239.1|2021-08-17",
	"England/CAMC-BD3A85/2020|OD902887.1|2020-11-28",
	"USA/FL-CDC-LC0242530/2021|OK197375.1|2021-08-30",
	"England/MILK-1E7D692/2021|2021-09-16",
	"England/CAMC-1332DF9/2021|OU024797.1|2021-02-26",
	"Scotland/QEUH-1408A30/2021|OU144814.1|2021-03-17",
	"USA/MO-UMGC-11467/2021|MZ994711.1|2021-08-16",
	"IMS-10006-CVDP-B986E280-C3C8-43AD-B013-6818DF873168|OU223671.1|2021-05-22",
	"USA/CA-CDPH-UC406/2020|MW972811.1|2020-11-17",
	"IMS-10087-CVDP-C380C035-BB68-44B6-BC21-1E0691035625|OU094490.1|2021-03-05",
	"England/NEWC-1F56467/2021|2021-09-23",
	"USA/TN-CDC-JHWN-0421/2020|MW864041.1|2020-12-16",
	"USA/NH-CDC-LC0047843/2021|MZ072092.1|2021-04-14",
	"USA/CO-CDC-MMB08567289/2021|OK241115.1|2021-04-29",
	"Switzerland/ZH-ETHZ-580004/2021|OU197913.1|2021-04-08",
	"England/BIRM-5E874/2020|2020-03-23",
	"USA/MN-MDH-5519/2021|MZ020684.1|2021-03-12",
	"USA/FL-BPHL-0642/2021|MW689732.1|2021-02-03",
	"USA/PA-CDC-2-3992458/2021|MZ779734.1|2021-02-23",
	"England/PHEP-037674/2021|2021-09-16",
	"USA/JEKD/2020|MW923474.1|2020-11-06",
	"USA/CO-CDC-ASC210030310/2021|MZ196016.1|2021-04-22",
	"USA/CA-CZB-25488/2021|MW736675.1|2021-01-17",
	"England/QEUH-186D015/2021|OU423695.1|2021-07-04",
	"USA/WI-CDC-LC0003313/2021|MW639133.1|2021-01-11",
	"USA/NY-CDC-QDX24520448/2021|MZ270350.1|2021-05-01",
	"BHR/340861785/2020|MW242707.1|2020-10-14",
	"USA/GA-CDC-STM-000017184/2021|MW777773.1|2021-02-16",
	"USA/WI-CDC-ASC210070121/2021|MZ085926.1|2021-04-14",
	"IMS-10264-CVDP-8B41D8D5-236C-4BEC-AF5C-4B60BE853356|OU159914.1|2020-12-14",
	"Switzerland/ZH-ETHZ-33552005/2021|OU573779.1|2021-07-22",
	"Germany/2021|OU567784.1|2021-08-05",
	"USA/IL-CDC-ASC210029021/2021|MZ284189.1|2021-04-21",
	"USA/NC-CDC-FG-035033/2021|MZ293815.1|2021-05-04",
	"USA/WA-UW-21042259669/2021|MZ171970.1|2021-04-22",
	"USA/FL-CDC-STM-000062183/2021|MZ164278.1|2021-04-23",
	"England/NEWC-1E50B1E/2021|OU730274.1|2021-09-13",
	"England/ALDP-B62B6A/2020|OB996941.1|2020-11-08",
	"USA/SC-COVID21-2776/2021|MZ854356.1|2021-07-27",
	"USA/NV-CDC-QDX21841266/2021|MW669157.1|2021-02-07",
	"Wales/PHWC-PDQKM8/2021|2021-08-30",
	"England/QEUH-196C8E0/2021|OU455424.1|2021-07-16",
	"USA/CA-CDC-FG-104153/2021|OK063393.1|2021-08-26",
	"USA/NC-CDC-LC0253312/2021|OK198655.1|2021-08-31",
	"England/MILK-1E0B7D2/2021|OU720176.1|2021-09-10",
	"England/ALDP-17F82DE/2021|OU388229.1|2021-06-27",
	"Scotland/QEUH-1E05E6A/2021|OU721045.1|2021-09-09",
	"IMS-10146-CVDP-AF8DE0C9-E7B5-4C2A-8D09-9B748CDED96A|OU127054.1|2021-04-09",
	"England/QEUH-1408317/2021|OU090917.1|2021-03-18",
	"USA/MA-CDCBI-CRSP_53H3TYB6SQXJYSMV/2021|MZ933800.1|2021-08-16",
	"USA/WA-CDC-LC0203228/2021|OK101449.1|2021-08-13",
	"USA/MA-CDC-LC0023182/2021|MW986042.1|2021-02-24",
	"USA/NM-CDC-IBX980138795634/2021|OK305726.1|2021-09-08",
	"IMS-10203-CVDP-3505E3F6-4707-41E5-A122-B485D13E6EB4|OU085255.1|2021-02-27",
	"England/ALDP-4A20A2/2020|OA981378.1|2020-05-18",
	"USA/CA-CZB-16964/2020|MZ842258.1|2020-12-15",
	"USA/OH-CDC-ASC210099476/2021|OK223319.1|2021-09-02",
	"USA/CO-CDC-FG-017492/2021|MW933641.1|2021-03-29",
	"USA/CA-CDC-ASC210206404/2021|OK015179.1|2021-07-31",
	"EGY/Third-Wave-EGY-ARMY21/2021|MZ042982.1|2021-04-09",
	"Switzerland/GE-33284365/2021|FR992074.1|2021-02-15",
	"England/MILK-9E047A/2020|OA999395.1|2020-09-20",
	"Northern_Ireland/NIRE-00b5ee/2021|2021-08-09",
	"USA/CT-CDC-LC0212267/2021|OK115305.1|2021-08-19",
	"USA/WA-CDC-UW21041802144/2021|MZ132128.1|2021-04-18",
	"Wales/PHWC-PDIQE4/2021|2021-09-15",
	"USA/PA-CDC-LC0057995/2021|MZ253340.1|2021-05-04",
	"England/NORT-YYGD36/2021|2021-09-26",
	"USA/FL-BPHL-2403/2020|MW490996.1|2020-10-20",
	"USA/AR-CDC-LC0168407/2021|MZ943487.1|2021-08-03",
	"USA/WA-CDC-FG-057388/2021|MZ765936.1|2021-07-30",
	"England/CAMC-11B42D4/2021|OD972706.1|2021-01-30",
	"England/PHEC-W308WCB6/2021|2021-08-24",
	"England/MILK-17D7D4D/2021|OU381549.1|2021-06-26",
	"USA/NM-CDC-LC0003097/2021|MW638156.1|2021-01-09",
	"England/MILK-B38848/2020|OC996560.1|2020-11-01",
	"AUS/VIC16673/2020|MW277509.1|2020-08-06",
	"USA/TX-CDC-STM-000020572/2021|MW942249.1|2021-02-20",
	"USA/FL-BPHL-0949/2020|MT966076.1|2020-07-07",
	"USA/CO-CDC-LC0027832/2021|MW870088.1|2021-03-11",
	"England/PHEC-W304WFDF/2021|2021-08-17",
	"USA/MN-CDC-IBX998707341008/2021|MZ034475.1|2021-04-09",
	"USA/PA-CDC-ASC210058177/2021|MZ238637.1|2021-05-03",
	"England/CAMB-1AB15E/2020|FR999407.1|2020-04-19",
	"England/MILK-A47ABA/2020|OA996691.1|2020-10-06",
	"IMS-10020-CVDP-B7E7D4DB-3924-4099-8C3F-CA3A6D1DA03D|OU187018.1|2021-05-01",
	"England/PHEC-30EB95/2021|2021-05-18",
	"England/SHEF-CF692/2020|2020-09-18",
	"IMS-10150-CVDP-4F61E59B-035C-43BF-8932-3356BE1F76E5|OU517554.1|2021-07-27",
	"USA/GA-CDC-ASC210232501/2021|OK023179.1|2021-07-28",
	"Switzerland/BL-ETHZ-450392/2021|OE995817.1|2021-01-11",
	"USA/GA-CDC-ASC210209609/2021|OK016291.1|2021-08-02",
	"England/MILK-B3D421/2020|2020-10-31",
	"Wales/PHWC-4C3C6B/2021|2021-01-31",
	"England/QEUH-172CE82/2021|OU355250.1|2021-06-17",
	"USA/CA-CDC-LC0083764/2021|MZ554557.1|2021-06-24",
	"England/PHEC-Y306YA72/2021|2021-09-01",
	"USA/DC-CDC-LC0008099/2021|MW638056.1|2021-01-19",
	"USA/MD-CDC-ASC210061705/2021|MZ244615.1|2021-05-09",
	"England/QEUH-18F0299/2021|OU440068.1|2021-07-11",
	"USA/TX-CDC-ASC210118389/2021|OK118684.1|2021-08-17",
	"England/QEUH-1A6C17B/2021|OU506276.1|2021-07-28",
	"USA/TX-CDC-ASC210049872/2021|MZ083989.1|2021-04-06",
	"USA/AR-CDC-ASC210112101/2021|MZ705987.1|2021-07-08",
	"England/PLYM-16916DC/2021|2021-06-10",
	"USA/NV-CDC-QDX21640300/2021|MW666382.1|2021-02-01",
	"Wales/PHWC-4BCAB6/2021|2021-01-17",
	"Scotland/QEUH-18307BC/2021|OU413018.1|2021-07-01",
	"USA/FL-CDC-ASC210208934/2021|OK012888.1|2021-08-02",
	"England/ALDP-1145A1C/2021|OD963370.1|2021-01-22",
	"IMS-10013-CVDP-13FA1928-1779-496F-AE9E-CBE296A7CB2C|OU155139.1|2021-04-30",
	"England/PHWC-PYKR7U/2021|2021-06-24",
	"USA/AZ-CDC-LC0060300/2021|MZ306860.1|2021-05-17",
	"England/CAMC-B7AB41/2020|2020-11-13",
	"England/ALDP-19CBEDE/2021|OU463865.1|2021-07-21",
	"England/NORW-304C926/2021|2021-09-24",
	"USA/AR-CDC-QDX24155105/2021|MZ173166.1|2021-04-20",
	"USA/VT-CDCBI-CRSP_KVU7NGOLYVD4HHG4/2021|OK176174.1|2021-09-06",
	"Germany/2021|OU566294.1|2021-08-05",
	"USA/IN-CDC-2-3880618/2021|MW709208.1|2021-01-29",
	"England/ALDP-1AA4F13/2021|OU531609.1|2021-08-01",
	"USA/CA-CDC-ASC210192941/2021|OK118117.1|2021-08-20",
	"USA/NC-CDC-LC0243383/2021|OK197890.1|2021-08-31",
	"USA/KS-CDC-2-4308010/2021|MZ164835.1|2021-04-17",
	"USA/MA-CDCBI-CRSP_NQ4UMHFKBRV2QNOO/2021|MZ983101.1|2021-08-23",
	"England/ALDP-18481A4/2021|OU411272.1|2021-06-29",
	"England/NOTT-24C74D/2021|OU030284.1|2021-01-17",
	"England/BRBR-1B10A98/2021|OU554818.1|2021-08-06",
	"England/RAND-1421DFC/2021|OU145599.1|2021-03-02",
	"USA/PA-CDC-STM-000068776/2021|MZ279296.1|2021-05-04",
	"USA/MA-MASPHL-04521/2021|MZ854838.1|2021-08-08",
	"England/ALDP-1F680AA/2021|2021-09-24",
	"England/ALDP-1B030D2/2021|OU532626.1|2021-08-04",
	"England/ALDP-AA181E/2020|2020-10-22",
	"USA/NJ-CDC-IBX098582920631/2021|OK108677.1|2021-08-20",
	"USA/WA-CDC-UW21081647644/2021|OK067993.1|2021-08-16",
	"USA/TN-CDC-LC0262466/2021|OK277486.1|2021-09-02",
	"USA/OSPHL02915/2021|OK283637.1|2021-09-17",
	"USA/TX-CDC-ASC210273167/2021|OK005388.1|2021-08-04",
	"IMS-10103-CVDP-0A0A8857-B661-4540-A99D-B709D63D83F3|OU211397.1|2021-05-19",
	"England/LEED-2A925C/2020|OA971902.1|2020-04-06",
	"USA/TX-DSHS-2757/2020|MW738879.1|2020-06-15",
	"USA/KS-QDX-3351/2020|MW522413.1|2020-09-27",
	"USA/DE-CDC-ASC210247116/2021|MZ995989.1|2021-07-27",
	"England/PHEC-3J06AJ81/2021|2021-09-29",
	"USA/NV-CDC-LC0149356/2021|MZ866843.1|2021-07-19",
	"USA/FL-CDC-ASC210104123/2021|OK225523.1|2021-09-03",
	"USA/AZ-CDC-ASC210155615/2021|MZ729092.1|2021-07-01",
	"Scotland/QEUH-A63B97/2020|2020-10-09",
	"USA/UT-UPHL-210806391823/2021|MZ834915.1|2021-07-07",
	"England/MILK-11EB4DE/2021|OD970891.1|2021-02-01",
	"Wales/PHWC-4D2B6C/2021|2021-02-21",
	"England/NEWC-1E0B1C5/2021|OU725356.1|2021-09-10",
	"IMS-10225-CVDP-7E92D20C-CE9D-4637-916D-21E008C19632|OU327199.1|2021-06-10",
	"USA/WV119063/2021|MZ498151.1|2021-04-15",
	"USA/IL-CDC-QDX28549900/2021|OK262529.1|2021-09-01",
	"USA/SRL_329725595/2021|OK172381.1|2021-08-17",
	"USA/CA-CDC-QDX25931043/2021|OK251795.1|2021-06-16",
	"USA/CA-CHLA-PLM73393837/2020|MZ622501.1|2020-11-27",
	"USA/CA-CDC-FG-036831/2021|MZ384109.1|2021-06-03",
	"USA/MO-CDC-ASC210155939/2021|MZ705413.1|2021-07-07",
	"USA/TX-CDC-QDX21841593/2021|MW669179.1|2021-02-07",
	"Switzerland/VD-ETHZ-560245/2021|OU172845.1|2021-03-29",
	"USA/FL-CDC-STM-000068703/2021|MZ279276.1|2021-05-04",
	"USA/TX-CDC-IBX036850531371/2020|MZ167004.1|2020-06-24",
	"USA/TN-CDC-ASC210135351/2021|OK288699.1|2021-09-08",
	"USA/PA-CDC-LC0051273/2021|MZ141892.1|2021-04-23",
	"USA/TN-CDC-ASC210188875/2021|OK010610.1|2021-08-06",
	"USA/HI-CDC-LC0233826/2021|OK134920.1|2021-08-23",
	"USA/UT-UPHL-210820924226/2021|OK040008.1|2021-08-07",
	"USA/WA-CDC-FG-037167/2021|MZ409865.1|2021-06-05",
	"USA/MO-CDC-LC0181177/2021|MZ991952.1|2021-08-06",
	"USA/UT-UPHL-210722682830/2021|MZ732052.1|2021-03-12",
	"USA/GA-CDC-STM-000061988/2021|MZ164170.1|2021-04-23",
	"England/ALDP-C8C97E/2020|OD917406.1|2020-12-15",
	"England/ALDP-1B0349A/2021|OU532770.1|2021-08-03",
	"USA/AZ-CDC-STM-000022620/2021|MW942705.1|2021-02-24",
	"England/CAMC-B086CF/2020|OB992839.1|2020-10-29",
	"USA/MN-MDH-4228/2021|MW821868.1|2021-02-26",
	"USA/NJ-CDC-STM-000008805/2021|MW672705.1|2021-02-04",
	"USA/WI-UW-102/2020|MT706222.1|2020-03-30",
	"USA/MN-CDC-IBX758117260709/2021|OK204365.1|2021-09-04",
	"England/PHEC-14FD76/2020|2020-12-16",
	"England/PHEC-X30AXA23/2021|2021-09-07",
	"USA/MA-CDCBI-CRSP_RH3TIUQTAZUZW4SZ/2021|MZ145787.1|2021-04-26",
	"USA/MA-CDC-LC0238990/2021|OK195642.1|2021-08-26",
	"USA/GA-CDC-STM-000035639/2021|MW908396.1|2021-03-13",
	"AUS/VIC3889/2020|MT970259.1|2020-07-13",
	"Scotland/QEUH-1741546/2021|OU350280.1|2021-06-18",
	"USA/MN-MDH-3943/2021|MW813876.1|2021-03-09",
	"IMS-10020-CVDP-916F394B-3E72-4D32-8D45-F8D3DBEA16FC|OU115006.1|2021-04-05",
	"USA/NY-CDC-FG-062072/2021|MZ764033.1|2021-08-01",
	"England/ALDP-10142B5/2021|OD943586.1|2021-01-13",
	"Germany/2021|OU567501.1|2021-07-31",
	"England/CAMC-13D46FE/2021|OU066771.1|2021-03-12",
	"AUS/VIC6826/2020|MW154870.1|2020-07-24",
	"USA/CO-CDC-MMB09284860/2021|MZ618124.1|2021-07-01",
	"England/MILK-9A96D1/2020|OA973635.1|2020-09-01",
	"England/ALDP-8C3E70/2020|OA978449.1|2020-06-25",
	"England/CAMC-1328E5D/2021|OU027965.1|2021-02-17",
	"USA/MN-UMGC-3790/2021|MZ454444.1|2021-05-27",
	"USA/MN-UMGC-13365/2021|OK140105.1|2021-08-23",
	"USA/GA-CDC-LC0186733/2021|MZ987150.1|2021-08-13",
	"USA/NC-CDC-LC0078545/2021|MZ531282.1|2021-06-15",
	"England/BRBR-19535A9/2021|OU453549.1|2021-07-14",
	"Scotland/MILK-152AD10/2021|OU274200.1|2021-04-21",
	"USA/TX-CDC-QDX26487804/2021|MZ655386.1|2021-06-30",
	"England/PLYM-1A82607/2021|OU532436.1|2021-07-30",
	"USA/TX-CDC-LC0169517/2021|MZ943007.1|2021-07-20",
	"USA/KY-CDC-LC0169875/2021|MZ942988.1|2021-07-20",
	"USA/GA-CDC-MMB09673157/2021|OK109725.1|2021-08-10",
	"USA/UT-UPHL-2104158304/2021|MZ089877.1|2021-01-16",
	"England/QEUH-CC23E7/2020|OD913587.1|2020-12-21",
	"IMS-10082-CVDP-0C965ABC-9400-40AE-9880-F2C5F3D73EFD|OU569597.1|2021-08-13",
	"England/HSLL-1E3F15F/2021|OU729203.1|2021-09-11",
	"USA/NY-CDC-LC0172390/2021|MZ942054.1|2021-08-08",
	"USA/VSP0609/2020|OK245630.1|2020-12-15",
	"USA/MA-CDC-LC0021236/2021|MW779670.1|2021-03-01",
	"USA/AL-CDC-ASC210239368/2021|MZ953231.1|2021-08-03",
	"USA/IL-CDC-QDX24603914/2021|MZ278512.1|2021-05-03",
	"USA/TX-CDC-ASC210193883/2021|OK118154.1|2021-08-20",
	"USA/MD-CDC-LC0023213/2021|MW986124.1|2021-03-02",
	"USA/WI-CDC-LC0101006/2021|MZ785207.1|2021-07-10",
	"USA/VA-CDC-ASC210074844/2021|MZ188689.1|2021-04-18",
	"USA/TG772629/2021|MZ911209.1|2021-03-03",
	"USA/VA-CDC-LC0259583/2021|OK280637.1|2021-09-07",
	"USA/VSP2966/2021|MZ512988.1|2021-05-24",
	"IMS-10020-CVDP-492C62E7-1C41-4160-9D6C-F0FC1ADA5358|OU131774.1|2021-04-13",
	"IMS-10375-CVDP-B8272D2C-1DF2-4EFB-9EB2-0BB753A54EF6|OU368316.1|2021-01-25",
	"AUS/VIC10503/2020|MW156533.1|2020-07-18",
	"England/MILK-1DDAED8/2021|2021-09-08",
	"USA/IN-CDC-LC0041907/2021|MZ037423.1|2021-04-01",
	"England/RAND-1485989/2021|OU227137.1|2021-03-26",
	"USA/WA-UW-21042174256/2021|MZ171913.1|2021-04-21",
	"USA/KY-GD-SID-21072634874/2021|MZ726554.1|2021-07-26",
	"England/QEUH-1B1C6D4/2021|OU554042.1|2021-08-06",
	"England/CAMC-13B7327/2021|OU068504.1|2021-03-09",
	"England/PHEC-30B2C0/2021|2021-04-26",
	"USA/NJ-CDC-LC0173913/2021|MZ944748.1|2021-08-01",
	"England/LOND-13696EF/2021|2021-08-03",
	"USA/AZ-3930/2021|MZ505835.1|2021-01-05",
	"IMS-10117-CVDP-37904B00-88F5-437D-A37D-0D39405E100F|OU108278.1|2021-03-03",
	"USA/IN-CDC-LC0043486/2021|MZ038957.1|2021-03-31",
	"Switzerland/BE-Risch-2182401905/2021|OU620691.1|2021-08-19",
	"USA/NY-CDC-LC0054319/2021|MZ180239.1|2021-04-29",
	"USA/TX-HHD-2104159031/2021|MW971467.1|2021-04-13",
	"IMS-10013-CVDP-B55FA135-6940-4EBE-9687-70BF5F39E538|OU095232.1|2021-02-22",
	"USA/OR-CDC-LC0056323/2021|MZ181996.1|2021-05-03",
	"USA/WI-CDC-ASC210017083/2021|MW880417.1|2021-03-23",
	"USA/IL-CDC-ASC210104436/2021|OK321362.1|2021-09-03",
	"England/ALDP-12834D7/2021|OD988399.1|2021-02-10",
	"USA/CA-CDC-LC0039582/2021|MZ003764.1|2021-03-30",
	"England/BRIS-12EBFB/2020|OA964555.1|2020-04-24",
	"Northern_Ireland/NIRE-001389/2021|2021-03-30",
	"USA/UT-UPHL-2104129574/2020|MZ294987.1|2020-08-20",
	"Switzerland/GE-33070014/2021|FR991317.1|2021-01-25",
	"USA/FL-BPHL-3721/2021|MZ398602.1|2021-04-26",
	"USA/WA-S1725/2020|MT834027.1|2020-06-01",
	"USA/MD-CDC-LC0049416/2021|MZ073282.1|2021-04-17",
	"IMS-10001-CVDP-9C9C4203-22F0-424F-8641-A29F41F399CB|OU198648.1|2021-04-12",
	"USA/KY-GD-090721-24/2021|OK158374.1|2021-08-24",
	"IMS-10619-CVDP-E8B2AACC-E3F7-41B7-85D7-EED9C79C8CEA|OU184671.1|2021-04-23",
	"USA/MN-CDC-IBX271588956919/2021|OK305557.1|2021-09-10",
	"USA/MN-MDH-13149/2021|OK244430.1|2021-09-05",
	"USA/CA-CDC-FG-007869/2021|MW860967.1|2021-03-08",
	"IMS-10013-CVDP-034EFEF4-3272-4F40-9480-AD142D3438E2|OU093823.1|2021-03-05",
	"USA/JFWY/2020|MW930551.1|2020-12-02",
	"USA/MI-CDC-STM-000068730/2021|MZ279311.1|2021-05-04",
	"USA/TX-DSHS-4755/2020|MW863181.1|2020-07-18",
	"USA/NY-CDC-LC0035807/2021|MZ000364.1|2021-03-26",
	"England/MILK-1E97D06/2021|2021-09-16",
	"England/PHEC-33B634/2021|2021-07-27",
	"IMS-10020-CVDP-1615ABEB-AE99-4770-BA92-21260CD7AB5C|OU091038.1|2021-02-25",
	"England/NORT-1B85427/2020|2020-12-28",
	"USA/MI-CDC-STM-000071057/2021|MZ291356.1|2021-05-06",
	"England/PHEC-T30BT961/2021|2021-05-06",
	"England/NEWC-1F74B40/2021|2021-09-25",
	"England/ALDP-12A0216/2021|OD986106.1|2021-02-12",
	"USA/IL-CDC-LC0170570/2021|MZ939243.1|2021-07-28",
	"England/ALDP-1BE3612/2021|OU590612.1|2021-08-16",
	"Scotland/QEUH-1E69277/2021|OU742269.1|2021-09-14",
	"USA/VA-CDC-LC0065447/2021|MZ371185.1|2021-05-26",
	"England/CAMC-9D74B2/2020|2020-09-20",
	"USA/FL-CDC-FG-031326/2021|MZ183715.1|2021-04-30",
	"USA/VA-CDC-LC0173743/2021|MZ944349.1|2021-07-29",
	"USA/NJ-CDC-LC0084786/2021|MZ555336.1|2021-06-24",
	"USA/FL-CDC-LC0040492/2021|MZ036568.1|2021-04-08",
	"IND/Barcode12MN908947.3/2021|OK189621.1|2021-09-10",
	"USA/FHCRC-9469/2020|MW593417.1|2020-05-18",
	"USA/NC-CDC-LC0259445/2021|OK280864.1|2021-09-07",
	"USA/CO-CDC-MMB09649937/2021|OK138189.1|2021-08-09",
	"USA/TX-CDC-FG-119385/2021|OK208758.1|2021-09-08",
	"USA/RI-CDC-8423/2020|MW473689.1|2020-12-15",
	"Scotland/EDB17537/2021|2021-04-13",
	"IMS-10294-CVDP-00227|OU077158.1|2020-12-03",
	"USA/CA-CDC-2-3903659/2021|MZ779478.1|2021-02-04",
	"USA/OR-CDC-LC0039051/2021|MZ003211.1|2021-03-30",
	"England/ALDP-1F6C880/2021|2021-09-24",
	"USA/MD-CDC-MMB09634067/2021|MZ998180.1|2021-08-06",
	"USA/WA-CDC-UW21080103692/2021|MZ967741.1|2021-08-01",
	"USA/FL-CDC-LC0065471/2021|OK231129.1|2021-05-26",
	"USA/CT-CDC-QDX23804242/2021|MZ045020.1|2021-04-08",
	"Switzerland/ZH-ETHZ-551439/2020|OU197231.1|2020-12-14",
	"USA/CA-CDC-LC0013622/2021|MW643998.1|2021-02-01",
	"Wales/PHWC-PDSPJZ/2021|2021-09-08",
	"USA/RI-CDC-LC0056942/2021|MZ252412.1|2021-05-06",
	"IMS-10257-CVDP-8C9B1925-F0EF-4771-B7D4-E9B5AE160A97|OU221659.1|2021-05-08",
	"USA/TX-DSHS-5811/2021|MZ048682.1|2021-04-10",
	"England/MILK-1EA11B2/2021|2021-09-15",
	"Switzerland/ZH-ETHZ-481576/2021|OU011092.1|2021-01-05",
	"USA/WA-CDC-QDX25316339/2021|MZ363359.1|2021-05-24",
	"USA/WA-S4699/2021|MW685679.2|2021-01-26",
	"USA/NJ-CDC-ASC210014109/2021|OK291402.1|2021-03-21",
	"USA/MI-CDC-STM-000046226/2021|MW932526.1|2021-03-30",
	"USA/FL-CDC-LC0219427/2021|OK153864.1|2021-08-23",
	"England/MILK-11C9BD1/2021|2021-01-31",
	"USA/CA-CDC-FG-070709/2021|MZ884201.1|2021-08-09",
	"USA/NJ-CDC-LC0177611/2021|MZ989298.1|2021-08-08",
	"Scotland/QEUH-1B05DBB/2021|OU553678.1|2021-08-05",
	"IMS-10013-CVDP-94F5037E-0455-45E8-9E66-177053EA1E6D|OU167775.1|2021-04-22",
	"Wales/PHWC-PYIZAU/2021|2021-07-20",
	"USA/NC-CDC-ASC210174373/2021|OK302443.1|2021-08-26",
	"England/MILK-1F97CDB/2021|2021-09-27",
	"England/BRBR-1BF31A5/2021|OU589066.1|2021-08-16",
	"England/QEUH-1A6A33B/2021|OU508001.1|2021-07-28",
	"USA/GA-CDC-QDX28050793/2021|OK061846.1|2021-08-21",
	"England/LEED-2A9456/2020|OA971458.1|2020-04-10",
	"USA/LA-CDC-1905/2020|MT997762.1|2020-05-07",
	"USA/CA-CDC-FG-081711/2021|MZ900151.1|2021-08-16",
	"England/ALDP-1AA7F2F/2021|OU543405.1|2021-08-01",
	"England/LOND-D68A1/2020|OA964268.1|2020-04-24",
	"USA/MA-CDCBI-CRSP_W3MD2SJN3INPH6JV/2021|MZ934117.1|2021-08-16",
	"OU570408.1|2021-07-24",
	"USA/TX-CDC-FG-124369/2021|OK260424.1|2021-09-07",
	"England/ALDP-B1F57D/2020|OB993840.1|2020-11-01",
	"USA/VA-CDC-QDX28131007/2021|OK095463.1|2021-08-23",
	"USA/DC-CDC-LC0000462/2020|MW984704.1|2020-12-27",
	"IMS-10020-CVDP-8B5F3CC5-323C-4F5E-A001-D183F6C8221E|OU176924.1|2021-04-29",
	"England/RAND-1AE3F72/2021|OU529813.1|2021-07-22",
	"USA/MA-CDC-ASC210249072/2021|MZ996274.1|2021-07-27",
	"USA/CA-CDC-FG-126910/2021|OK306687.1|2021-09-14",
	"USA/WA-CDC-UW21081444630/2021|MZ951959.1|2021-08-14",
	"England/CAMC-139A973/2021|OU057948.1|2021-03-03",
	"USA/CA-CDC-ASC210125306/2021|OK228840.1|2021-09-02",
	"USA/CA-CDPH-3000132704/2021|OK323936.1|2021-07-30",
	"USA/FL-CDC-ASC210037591/2021|MZ282303.1|2021-05-02",
	"USA/RI-CDC-LC0050102/2021|MZ140951.1|2021-04-20",
	"Switzerland/ZH-ETHZ-440119/2021|OU009358.1|2021-01-03",
	"USA/FL-CDC-LC0241538/2021|OK196743.1|2021-08-30",
	"England/LOND-E1937/2021|OU419677.1|2021-02-11",
	"England/BRIS-127442/2020|FR998878.1|2020-04-22",
	"USA/CA-CHLA-PLM37584576/2020|MZ722329.1|2020-12-22",
	"USA/MA-CDCBI-CRSP_24JIXXGKLCMBWJGN/2021|OK177183.1|2021-09-08",
	"Switzerland/AG-42447043/2020|OU280372.1|2020-09-18",
	"USA/MN-MDH-3520/2021|MW751509.1|2021-02-13",
	"England/BRBR-1850D0F/2021|OU410753.1|2021-07-03",
	"USA/MN-CDC-IBX203981650556/2021|MZ951750.1|2021-08-13",
	"USA/IL-CDC-ASC210106164/2021|MZ375967.1|2021-05-29",
	"England/QEUH-962AC9/2020|OA969011.1|2020-08-10",
	"England/ALDP-6E90BC/2020|OA979485.1|2020-06-30",
	"IMS-10117-CVDP-0989B563-C68D-490B-B3B5-27082EE347CD|OU116464.1|2021-03-16",
	"USA/AZ-4301/2021|MZ604614.1|2021-07-11",
	"USA/UT-UPHL-210707477869/2021|MZ728303.1|2021-06-22",
	"England/ALDP-1F61DD7/2021|2021-09-21",
	"England/ALDP-1E2C2CB/2021|OU722143.1|2021-09-10",
	"England/QEUH-C1875F/2020|OD925386.1|2020-12-07",
	"England/BRBR-1B0F11F/2021|OU542699.1|2021-08-05",
	"USA/MI-CDC-STM-000046158/2021|MW932451.1|2021-03-29",
	"USA/MA-CDCBI-CRSP_MHRCQMKDA654BCD2/2021|OK034876.1|2021-08-26",
	"England/NORT-1BBFB10/2021|OU396418.1|2021-05-17",
	"England/MILK-12CC33F/2021|OU013424.1|2021-02-17",
	"IMS-10150-CVDP-321C256B-4B3C-4026-AAA1-9EC95629E658|OU222720.1|2021-05-26",
	"USA/VSP3004/2021|MZ579308.1|2021-02-03",
	"England/QEUH-1A1841B/2021|OU505494.1|2021-07-25",
	"England/PLYM-1A7EB4B/2021|OU524318.1|2021-07-30",
	"USA/JEMI/2020|MW928177.1|2020-11-10",
	"USA/CA-CDC-LC0252953/2021|OK203336.1|2021-08-30",
	"IMS-10036-CVDP-5D7450A5-A3CD-4741-9072-4CB27D369814|OU071883.1|2021-02-10",
	"USA/CA-CZB-27785/2021|MW923203.1|2021-02-26",
	"USA/NMDOH-2021153223/2021|OK087083.1|2021-08-18",
	"USA/CA-UCSF-UC715/2020|MW973430.1|2020-12-28",
	"USA/CA-CDC-ASC210065586/2021|MZ320083.1|2021-05-19",
	"USA/WA-UW-2021040106762/2021|MZ236611.1|2021-04-01",
	"USA/PA-CDC-QDX23997407/2021|MZ131374.1|2021-04-11",
	"England/ALDP-17363A4/2021|OU353332.1|2021-06-16",
	"IMS-10375-CVDP-19422608-764F-4C10-81D0-A24CCC0C77D0|OU368025.1|2021-01-14",
	"England/ALDP-1446C4F/2021|OU207674.1|2021-03-20",
	"Wales/ALDP-C39A13/2020|OD915764.1|2020-12-07",
	"Switzerland/BE-UHB-42970531/2021|OU570970.1|2021-07-28",
	"England/CAMC-120A5E4/2021|OD981032.1|2021-02-05",
	"USA/VSP5243/2021|OK247023.1|2021-07-16",
	"Switzerland/BE-ETHZ-34016909/2021|OU735052.1|2021-09-07",
	"Switzerland/GE-HUG-34928197/2021|OU576245.1|2021-07-31",
	"Wales/PHWC-4C74F6/2021|2021-02-05",
	"England/ALDP-B63291/2020|OB998404.1|2020-11-08",
	"USA/MI-CDC-QDX23572550/2021|MW959396.1|2021-04-01",
	"USA/CO-CDPHE-2100240557/2021|MW629271.1|2021-01-19",
	"England/QEUH-C34016/2020|OD910800.1|2020-12-11",
	"USA/CA-CDC-STM-000013507/2021|MW694203.1|2021-02-13",
	"Wales/PHWC-488691/2020|2020-10-28",
	"England/MILK-1EB6035/2021|2021-09-17",
	"IMS-10020-CVDP-DD7C47A5-AF08-48BB-9CB4-2693B7CC7D3E|OU119749.1|2021-03-29",
	"England/ALDP-1F56ED2/2021|2021-09-23",
	"1|OU324829.1|2021-05-01",
	"England/MILK-162EBE4/2021|OU316941.1|2021-06-05",
	"England/ALDP-1201E2E/2021|OD973515.1|2021-02-03",
	"USA/OH-CDC-ASC210239822/2021|OK009474.1|2021-08-07",
	"USA/RI-CDC-2-3993096/2021|MW792805.1|2021-02-23",
	"Switzerland/AG-ETHZ-420060/2020|OD997374.1|2020-12-18",
	"Scotland/QEUH-19E366F/2021|OU487155.1|2021-07-22",
	"USA/AZ-CDC-LC0016378/2021|MW706238.1|2021-02-09",
	"AUS/VIC5764/2020|MT971687.1|2020-07-21",
	"IMS-10013-CVDP-95EED1C4-BC86-409E-9140-F1089B4AD9E9|OU129653.1|2021-04-09",
];
